import { Sparkles } from "lucide-react";

const FIELD_LABELS = {
  document_title: ["Tytuł dokumentu", "Document title"],
  authority: ["Organ", "Authority"],
  gmina: ["Gmina", "Gmina"],
  publication_date: ["Data publikacji", "Publication date"],
  adoption_date: ["Data uchwalenia", "Adoption date"],
  parcel_references: ["Odniesienia do działek", "Parcel references"],
  planning_zone: ["Strefa planistyczna", "Planning zone"],
  allowed_uses: ["Dozwolone użytki", "Allowed uses"],
  prohibited_uses: ["Użytki zabronione", "Prohibited uses"],
  development_intensity: ["Intensywność zabudowy", "Development intensity"],
  max_building_height: ["Maks. wysokość zabudowy", "Max building height"],
  biologically_active_area: ["Powierzchnia biologicznie czynna", "Biologically active area"],
  environmental_restrictions: ["Ograniczenia środowiskowe", "Environmental restrictions"],
  infrastructure_references: ["Infrastruktura", "Infrastructure references"],
  agricultural_restrictions: ["Ograniczenia rolne", "Agricultural restrictions"],
  deadlines: ["Terminy", "Deadlines"],
  summary_pl: ["Podsumowanie", "Summary"],
};

export default function ExtractionPanel({ extraction, t, lang }) {
  if (!extraction) return null;
  const fields = extraction.fields || {};
  return (
    <div data-testid="ai-extraction-panel" className="mt-3 rounded-lg border border-indigo-200 bg-indigo-50/50 p-4">
      <p className="flex items-center gap-2 text-xs font-bold uppercase tracking-wide text-indigo-700">
        <Sparkles size={13} /> {t("ai.extracted")}
      </p>
      <p className="mt-1 text-[11px] text-slate-600">
        {(lang === "pl" ? extraction.note_pl : extraction.note_en)} · model: {extraction.model} · {new Date(extraction.extracted_at).toLocaleString("pl-PL")}
      </p>
      <dl className="mt-3 grid gap-x-6 gap-y-2 sm:grid-cols-2">
        {Object.entries(fields).map(([key, f]) => {
          const val = f && typeof f === "object" ? f.value : f;
          const conf = f && typeof f === "object" ? f.confidence : null;
          const display = Array.isArray(val) ? (val.length ? val.join("; ") : null) : val;
          const needsReview = display === "Wymaga weryfikacji" || (conf !== null && conf < 0.7);
          const label = FIELD_LABELS[key] ? FIELD_LABELS[key][lang === "pl" ? 0 : 1] : key.replaceAll("_", " ");
          return (
            <div key={key} data-testid={`extraction-field-${key}`} className="border-b border-indigo-100 pb-1.5">
              <dt className="text-[11px] font-semibold uppercase tracking-wide text-slate-600">{label}</dt>
              <dd className={`text-sm ${needsReview ? "font-semibold text-amber-700" : "text-slate-800"}`}>
                {display ?? "—"}
                {conf !== null && conf !== undefined && (
                  <span className="ml-2 text-[10px] text-slate-500">conf {Math.round(conf * 100)}%</span>
                )}
              </dd>
            </div>
          );
        })}
      </dl>
    </div>
  );
}
